"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var services_1 = require("../../../../../shared/services");
var initialState = function () {
    return {
        paymentMethod: {},
        paymentMethods: {},
        paymentMethodConfig: {},
        loadingPaymentData: false,
        loadingCheckout: false,
        selectedMethod: services_1.appSessionStorage.getItem('checkout-payment-method', {}),
        paymentDetails: services_1.appSessionStorage.getItem('checkout-payment-details', {}),
        shippingOptions: services_1.appSessionStorage.getItem('checkout-shipping-options', {}),
        haspaymentErrorMessage: false,
        paymentErrorMessage: null,
        couponCode: services_1.appSessionStorage.getItem('checkout-coupon-code', ''),
        couponStatus: null,
        couponMessage: '',
        couponRequestIsLoading: false,
    };
};
var mutations = {
    SET_PAYMENT_METHOD: function (state, paymentMethod) {
        state.paymentMethod = paymentMethod;
    },
    SET_PAYMENT_METHODS: function (state, paymentMethods) {
        state.paymentMethods = paymentMethods;
    },
    SET_PAYMENT_METHOD_CONFIG: function (state, paymentMethodConfig) {
        state.paymentMethodConfig = paymentMethodConfig;
    },
    SET_LOADING_PAYMENT_DATA: function (state, status) {
        state.loadingPaymentData = status;
    },
    SET_LOADING_CHECKOUT: function (state, status) {
        state.loadingCheckout = status;
    },
    ADD_PAYMENT_DETAILS: function (state, detail) {
        state.paymentDetails = __assign(__assign({}, state.paymentDetails), detail);
        services_1.appSessionStorage.setItem('checkout-payment-details', state.paymentDetails);
    },
    REMOVE_PAYMENT_DETAILS: function (state, detail) {
        if (state.paymentDetails.hasOwnProperty(detail)) {
            delete state[detail];
        }
        services_1.appSessionStorage.setItem('checkout-payment-details', state.paymentDetails);
    },
    CLEAR_PAYMENT_DETAILS: function (state) {
        state.paymentDetails = {};
        services_1.appSessionStorage.removeItem('checkout-payment-details');
    },
    ADD_SHIPPING_OPTION: function (state, detail) {
        state.shippingOptions = __assign(__assign({}, state.shippingOptions), detail);
        services_1.appSessionStorage.setItem('checkout-shipping-options', state.shippingOptions);
    },
    REMOVE_SHIPPING_OPTION: function (state, detail) {
        if (state.shippingOptions.hasOwnProperty(detail)) {
            delete state[detail];
        }
        services_1.appSessionStorage.setItem('checkout-shipping-options', state.shippingOptions);
    },
    CLEAR_SHIPPING_OPTION: function (state) {
        state.shippingOptions = {};
        services_1.appSessionStorage.removeItem('checkout-shipping-options');
    },
    SET_COUPON_CODE: function (state, couponCode) {
        services_1.appSessionStorage.setItem('checkout-coupon-code', couponCode);
        state.couponCode = couponCode;
    },
    SET_COUPON_STATUS: function (state, status) {
        state.couponStatus = status;
    },
    SET_COUPON_MESSAGE: function (state, message) {
        state.couponMessage = message;
    },
    SET_COUPON_REQUEST_LOADING: function (state, status) {
        state.couponRequestIsLoading = status;
    },
    SET_SELECTED_PAYMENT_METHOD: function (state, method) {
        state.selectedMethod = method;
        services_1.appSessionStorage.setItem('checkout-payment-method', method);
    },
    SET_ERROR_MESSAGE: function (state, message) {
        state.haspaymentErrorMessage = true;
        state.paymentErrorMessage = message;
    }
};
var actions = {
    setPaymentMethod: function (_a, paymentMethod) {
        var state = _a.state, rootState = _a.rootState, rootGetters = _a.rootGetters, dispatch = _a.dispatch, commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var additionalData, _b, _billingAddress, _shippingAddress;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if ('undefined' === typeof paymentMethod) {
                            return [2 /*return*/];
                        }
                        commit('CheckoutTotals/SET_LOADING_TOTALS', true, { root: true });
                        additionalData = {};
                        if (paymentMethod['code'].includes('buckaroo')) {
                            additionalData['buckaroo_skip_validation'] = true;
                        }
                        return [4 /*yield*/, commit('SET_PAYMENT_METHOD', paymentMethod)];
                    case 1:
                        _c.sent();
                        _b = rootGetters['CheckoutCheckout/getAddressData'], _billingAddress = _b[0], _shippingAddress = _b[1];
                        return [4 /*yield*/, this.$mageClient.post(rootGetters['CheckoutGlobal/getApiPathWithQuoteMask'] + "/set-payment-information", {
                                email: rootState['CheckoutGlobal']['customerEmail'],
                                paymentMethod: {
                                    method: paymentMethod['code'],
                                    additional_data: additionalData,
                                },
                                billingAddress: _billingAddress,
                            })];
                    case 2:
                        _c.sent();
                        // Collect totals.
                        commit('CheckoutTotals/SET_LOADING_TOTALS', false, { root: true });
                        return [4 /*yield*/, dispatch('CheckoutCart/fetchCartTotals', 'payment', { root: true })];
                    case 3:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        });
    },
    collectPaymentMethods: function (_a) {
        var rootState = _a.rootState, rootGetters = _a.rootGetters, commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var _b, method_code, carrier_code, _c, _billingAddress, _shippingAddress, _extensionAttributes, data, paymentMethods, paymentConfig;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        commit('SET_LOADING_PAYMENT_DATA', true);
                        commit('CheckoutTotals/SET_LOADING_TOTALS', true, { root: true });
                        _b = rootState['CheckoutShipping']['shippingMethod'], method_code = _b.method_code, carrier_code = _b.carrier_code;
                        _c = rootGetters['CheckoutCheckout/getAddressData'], _billingAddress = _c[0], _shippingAddress = _c[1];
                        _extensionAttributes = rootState['CheckoutCheckout']['extensionAttributes'];
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, , 7, 8]);
                        return [4 /*yield*/, this.$mageClient.post(rootGetters['CheckoutGlobal/getApiPathWithQuoteMask'] + "/shipping-information", {
                                addressInformation: {
                                    shippingAddress: _shippingAddress,
                                    billingAddress: _billingAddress,
                                    shippingMethodCode: method_code,
                                    shippingCarrierCode: carrier_code,
                                    extensionAttributes: _extensionAttributes,
                                }
                            })];
                    case 2:
                        data = (_d.sent()).data;
                        paymentMethods = data['payment_methods'];
                        return [4 /*yield*/, this.$mageClient.post("/rest/" + rootState['CheckoutGlobal']['storeCode'] + "/V1/checkout/config", {
                                paymentMethods: paymentMethods.map(function (v) { return v['code']; })
                            })];
                    case 3:
                        paymentConfig = _d.sent();
                        // Collect totals.
                        return [4 /*yield*/, commit('CheckoutTotals/SET_TOTALS', data['totals'], { root: true })];
                    case 4:
                        // Collect totals.
                        _d.sent();
                        return [4 /*yield*/, commit('SET_PAYMENT_METHODS', paymentMethods)];
                    case 5:
                        _d.sent();
                        return [4 /*yield*/, commit('SET_PAYMENT_METHOD_CONFIG', paymentConfig.data[0]['payment'] || {})];
                    case 6:
                        _d.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        commit('SET_LOADING_PAYMENT_DATA', false);
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    },
    setSelectedPaymentMethod: function (_a, paymentMethod) {
        var state = _a.state, commit = _a.commit;
        commit('SET_SELECTED_PAYMENT_METHOD', paymentMethod);
    },
    addPaymentDetail: function (_a, paymentDetail) {
        var state = _a.state, commit = _a.commit;
        commit('ADD_PAYMENT_DETAILS', paymentDetail);
    },
    removePaymentDetail: function (_a, paymentDetail) {
        var state = _a.state, commit = _a.commit;
        commit('REMOVE_PAYMENT_DETAILS', paymentDetail);
    },
    addShippingOptions: function (_a, optionDetail) {
        var state = _a.state, commit = _a.commit;
        commit('ADD_SHIPPING_OPTION', optionDetail);
    },
    removeShippingOptions: function (_a, optionDetail) {
        var state = _a.state, commit = _a.commit;
        commit('REMOVE_SHIPPING_OPTION', optionDetail);
    },
    getCouponCode: function (_a) {
        var rootState = _a.rootState, rootGetters = _a.rootGetters, commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var data, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.$mageClient.get(rootGetters['CheckoutGlobal/getApiPathWithQuoteMask'] + "/coupons")];
                    case 1:
                        data = (_b.sent()).data;
                        if (data.length) {
                            commit('SET_COUPON_CODE', data);
                            commit('SET_COUPON_STATUS', true);
                            return [2 /*return*/, true];
                        }
                        return [2 /*return*/, false];
                    case 2:
                        e_1 = _b.sent();
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    },
    applyCouponCode: function (_a, payload) {
        var state = _a.state, rootGetters = _a.rootGetters, dispatch = _a.dispatch, commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var couponCode, data, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        couponCode = payload.hasOwnProperty('couponCode') ? payload.couponCode : payload;
                        commit('SET_COUPON_REQUEST_LOADING', true);
                        commit('CheckoutTotals/SET_LOADING_TOTALS', true, { root: true });
                        if (!couponCode.length) {
                            commit('SET_COUPON_STATUS', false);
                            commit('SET_COUPON_REQUEST_LOADING', false);
                            commit('SET_COUPON_MESSAGE', 'Please enter a valid code');
                            commit('CheckoutTotals/SET_LOADING_TOTALS', false, { root: true });
                            return [2 /*return*/];
                        }
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, 4, 6]);
                        return [4 /*yield*/, this.$mageClient.put(rootGetters['CheckoutGlobal/getApiPathWithQuoteMask'] + "/coupons/" + couponCode)];
                    case 2:
                        data = (_c.sent()).data;
                        if (data) {
                            commit('SET_COUPON_CODE', couponCode);
                            commit('SET_COUPON_STATUS', true);
                        }
                        return [3 /*break*/, 6];
                    case 3:
                        _b = _c.sent();
                        response = _b.response;
                        commit('SET_COUPON_MESSAGE', response.data.message);
                        commit('SET_COUPON_STATUS', false);
                        return [3 /*break*/, 6];
                    case 4:
                        commit('CheckoutTotals/SET_LOADING_TOTALS', false, { root: true });
                        return [4 /*yield*/, dispatch('CheckoutCart/fetchCartTotals', payload.hasOwnProperty('type') ? payload.type : 'payment', { root: true })];
                    case 5:
                        _c.sent();
                        commit('SET_COUPON_REQUEST_LOADING', false);
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    },
    removeCouponCode: function (_a, payload) {
        var rootGetters = _a.rootGetters, dispatch = _a.dispatch, commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var data, e_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        commit('SET_COUPON_REQUEST_LOADING', true);
                        commit('CheckoutTotals/SET_LOADING_TOTALS', true, { root: true });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 6]);
                        return [4 /*yield*/, this.$mageClient.delete(rootGetters['CheckoutGlobal/getApiPathWithQuoteMask'] + "/coupons")];
                    case 2:
                        data = (_b.sent()).data;
                        commit('SET_COUPON_CODE', '');
                        commit('SET_COUPON_STATUS', null);
                        return [3 /*break*/, 6];
                    case 3:
                        e_2 = _b.sent();
                        commit('SET_COUPON_MESSAGE', 'The coupon code could not be cancelled, please try again later.');
                        return [3 /*break*/, 6];
                    case 4:
                        commit('CheckoutTotals/SET_LOADING_TOTALS', false, { root: true });
                        return [4 /*yield*/, dispatch('CheckoutCart/fetchCartTotals', payload.type || 'payment', { root: true })];
                    case 5:
                        _b.sent();
                        commit('SET_COUPON_REQUEST_LOADING', false);
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    },
    placeOrder: function (_a) {
        var rootState = _a.rootState, state = _a.state, rootGetters = _a.rootGetters, commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var url, _b, _billingAddress, _shippingAddress, e_3, message;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        url = state.selectedMethod['code'].includes('buckaroo') ? rootGetters['CheckoutGlobal/getBuckarooApiPathWithQuoteMask'] + "/payment-information" : rootGetters['CheckoutGlobal/getApiPathWithQuoteMask'] + "/payment-information";
                        commit('SET_LOADING_CHECKOUT', true);
                        _b = rootGetters['CheckoutCheckout/getAddressData'], _billingAddress = _b[0], _shippingAddress = _b[1];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, 6, 7]);
                        return [4 /*yield*/, this.$mageClient.post(url, {
                                cartId: rootGetters['CheckoutGlobal/getQuoteIdentifier'],
                                email: rootState['CheckoutGlobal']['customerEmail'],
                                shippingOptions: state.shippingOptions,
                                paymentMethod: {
                                    method: state.selectedMethod['code'],
                                    additional_data: state.paymentDetails,
                                },
                                billingAddress: _billingAddress
                            })];
                    case 2: return [2 /*return*/, _c.sent()];
                    case 3:
                        e_3 = _c.sent();
                        return [4 /*yield*/, e_3.response.data];
                    case 4:
                        message = (_c.sent()).message;
                        return [4 /*yield*/, commit('SET_ERROR_MESSAGE', message)];
                    case 5:
                        _c.sent();
                        window.scrollTo(0, 0);
                        return [3 /*break*/, 7];
                    case 6:
                        commit('SET_LOADING_CHECKOUT', false);
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    }
};
var state = initialState();
var CheckoutPayment = {
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations
};
exports.default = CheckoutPayment;
